import { createSlice } from '@reduxjs/toolkit';
import { APP } from '../constants/storeConstants';

const initialState = {
  hasServerError: false,
  // serverError: null
};

const appSlice = createSlice({
  name: APP,
  initialState,
  reducers: {
    setServerErrors: (state, action) => {
      state.hasServerError = action.payload;
    }
  },
});

export const {
  setServerErrors } = appSlice.actions;

export default appSlice.reducer;
